"use client";

import React, { useEffect, useRef, useState } from "react";
type UseRevealOnScrollOptions = {
  once?: boolean;
  threshold?: number | number[];
  rootMargin?: string;
};
function useRevealOnScroll<T extends HTMLElement = HTMLElement>({
  once = true,
  threshold = 0.2,
  rootMargin = "0px"
}: UseRevealOnScrollOptions = {}) {
  const ref = useRef<T | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) {
      return;
    }
    if (typeof window === "undefined" || typeof IntersectionObserver === "undefined") {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (entry?.isIntersecting) {
        setIsVisible(true);
        if (once) {
          observer.unobserve(entry.target);
        }
      } else if (!once) {
        setIsVisible(false);
      }
    }, {
      threshold,
      rootMargin
    });
    observer.observe(node);
    return () => {
      observer.disconnect();
    };
  }, [once, rootMargin, threshold]);
  return {
    ref,
    isVisible
  };
}
const benefits = [{
  title: "Schnelle Lieferung",
  description: "Ihre neue Webseite ist in 7 bis 14 Tagen online – garantiert und ohne Kompromisse bei der Qualität.",
  icon: ""
}, {
  title: "Faire Festpreise",
  description: "Bis zu 70% günstiger als lokale Agenturen. Transparente Kosten ohne versteckte Gebühren.",
  icon: ""
}, {
  title: "Schweizer Qualität",
  description: "Eingetragenes Unternehmen in der Schweiz mit persönlicher Beratung und Vor-Ort-Service.",
  icon: ""
}, {
  title: "Konversionsfokus",
  description: "Jede Seite ist darauf ausgelegt, echte Anfragen und Neukunden für Ihr Unternehmen zu generieren.",
  icon: ""
}, {
  title: "Festpreis Garantie",
  description: "Was wir anbieten, das zahlen Sie. Kein Cent mehr, keine versteckten Kosten oder böse Überraschungen.",
  icon: ""
}, {
  title: "Persönlicher Kontakt",
  description: "Direkter Ansprechpartner für Ihr Projekt. Wir sind für Sie da, ohne anonymes Support-Ticket-System.",
  icon: ""
}];
export default function IhreVorteileMitUns() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="203861" id="der-digital-caribe-vorteil" className="bg-[#F9FAFB] text-[#0A1628] py-24 md:py-32 px-6 md:px-8 overflow-hidden">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-3xl md:text-[40px] leading-[1.2] font-bold text-[#0A1628] mb-16 text-center tracking-tight">Warum KMU uns vertrauen</h2>
        
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {benefits.map((benefit, i) => {
          return <div key={i} data-index={i} className="flex flex-col items-start p-8 bg-white border border-[#E5E7EB] rounded-[12px] hover:shadow-md transition-shadow duration-300 group">
                <div className="text-4xl mb-6 shrink-0" aria-hidden="true">
                  {benefit.icon}
                </div>
                <h3 className="font-default text-xl font-bold mb-4 text-[#0A1628] tracking-tight">
                  {benefit.title}
                </h3>
                <p className="font-default text-base text-[#4B5563] leading-relaxed">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}